import { DataCloudEventData } from '~/modules/services/analyticsService';
import { i18nStore, selectCurrentLanguage } from '../../../modules/stores/i18nStore';
import { selectIsGuestUser, selectUserContext, selectUserToken, userStore } from '../../stores/userStore';
import { AnalyticsWeightings } from '../analyticsWeightings';

export const EXTENSION_TYPE_LISTING = 'listing/extensions/force/listings/Listing';
export const EXTENSION_TYPE_CONSULTANT = 'listing/extensions/consultant/listings/Listing';

export interface DataCloudIdentityData {
    listingCategoryName?: string;
    orgedition?: string;
    orgId?: string;
    orgstatus?: string;
    context_topCategories?: string;
    context_mainCategory?: string;
    context_products?: string;
    context_region?: string;
    context_edition?: string;
    context_industry?: string;
    context_userRole?: string;
    context_userLinkedOrgs?: string;
    lastInstalledListings?: string;
}

export interface DataCloudAnalyticsEvent {
    userData: DataCloudIdentityData;
    language: string;
    outcome: number;
    anonymous: boolean;
    userAgent: string;
    username: string;
    clientId: string;
}
export interface DataCloudAnalyticsEventData {
    interaction: any;
    user: {
        attributes: DataCloudIdentityData & {
            eventType: string;
            deviceId: string;
        };
    };
}

export abstract class DataCloudEventType {
    abstract canHandle(event: DataCloudEventData): boolean;
    abstract getBody(event: DataCloudEventData): DataCloudAnalyticsEventData;

    baseBody(event: DataCloudEventData): DataCloudAnalyticsEvent {
        return {
            userData: {
                ...this.getUserCustomData(),
            },
            language: this.getCurrentLanguage(),
            outcome: AnalyticsWeightings.defaultPoints,
            anonymous: !event.authenticated,
            userAgent: event.browser,
            username: selectUserToken(userStore.getState()),
            clientId: selectUserToken(userStore.getState()),
        };
    }

    private getUserCustomData(): DataCloudIdentityData {
        const isGuestUser = selectIsGuestUser(userStore.getState());
        if (!isGuestUser) {
            const userContext = selectUserContext(userStore.getState());
            return {
                orgId: userContext?.orgid || '',
                orgedition: userContext?.orgedition || '',
                orgstatus: userContext?.orgstatus || '',
                context_topCategories: userContext?.topCategories?.join(';') || '',
                context_mainCategory: userContext?.mainCategory || '',
                context_products: userContext?.products?.join(';') || '',
                context_region: userContext?.region || '',
                context_edition: Array.isArray(userContext?.orgedition)
                    ? userContext.orgedition.join(';')
                    : userContext?.orgedition || '',
                context_industry: Array.isArray(userContext?.industry)
                    ? userContext.industry.join(';')
                    : userContext?.industry || '',
                context_userRole: userContext?.userRole || '',
                context_userLinkedOrgs: Array.isArray(userContext?.userLinkedOrgs)
                    ? userContext.userLinkedOrgs.join(';')
                    : userContext?.userLinkedOrgs || '',
                lastInstalledListings: Array.isArray(userContext?.lastInstalledListings)
                    ? userContext.lastInstalledListings.join(';')
                    : userContext?.lastInstalledListings || '',
            };
        }
        return {};
    }

    private getCurrentLanguage() {
        return selectCurrentLanguage(i18nStore.getState());
    }

    // @ts-expect-error * Automated Type Error Fix
    getListingCategories(categories) {
        return categories
            ? // @ts-expect-error * Automated Type Error Fix
              categories.map((category) => {
                  if (typeof category == 'string') {
                      return category;
                  }
                  return category.name;
              })
            : [];
    }
}
